module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-card",
    class: {
      'hover': _vm.hover
    },
    on: {
      "mouseover": function($event) {
        _vm.hover = true
      },
      "mouseout": function($event) {
        _vm.hover = false
      }
    }
  }, [_c('div', {
    staticClass: "cover-wrapper"
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "status",
    class: {
      'expired': _vm.state === 'expired', 'temp': _vm.state === 'temp', 'completed': _vm.state === 'completed'
    }
  }, [_vm._v(_vm._s(_vm.$t(("project.state." + _vm.state))))]), _vm._v(" "), (_vm.project.thumbnail_url) ? _c('div', {
    staticClass: "img cover",
    style: ({
      backgroundImage: 'url(' + _vm.project.thumbnail_url + ')'
    })
  }) : _c('div', {
    staticClass: "img cover default"
  })]), _vm._v(" "), _c('div', {
    staticClass: "hover-actions-group"
  }, [_c('div', {
    staticClass: "qrcode",
    class: {
      'show': _vm.qrcode
    }
  }, [_c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: 'url(' + '//qrcode.ppj.io/' + _vm.project.viewer_url + ')'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "action",
    class: {
      'disabled': !_vm.available
    }
  }, [(_vm.available) ? _c('a', {
    staticClass: "block-btn",
    attrs: {
      "href": _vm.project.viewer_url,
      "target": "_blank"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.check')))])]) : _c('a', {
    staticClass: "block-btn"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t(("project.state." + _vm.state))))])])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.readonly),
      expression: "!readonly"
    }],
    staticClass: "action",
    attrs: {
      "to": ("/projects/" + (_vm.project.id)),
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ppj-icon-pencil"
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('common.buttons.edit')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.readonly),
      expression: "!readonly"
    }],
    staticClass: "action"
  }, [_c('a', {
    staticClass: "block-btn",
    on: {
      "click": _vm.alterSource
    }
  }, [_vm._m(2), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('actions.project.updatePPT')))])])])], 1), _vm._v(" "), (!_vm.project.permanent && !_vm.tbcMode) ? _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.readonly),
      expression: "!readonly"
    }],
    staticClass: "upgrade",
    attrs: {
      "plain": true
    },
    on: {
      "click": _vm.upgrade
    }
  }, [_c('i', {
    staticClass: "ppj-icon-star",
    staticStyle: {
      "margin-right": "0.4em"
    }
  }), _vm._v("升级永久\n    ")]) : _vm._e(), _vm._v(" "), (_vm.tbcMode && _vm.project.tbc && _vm.state === 'completed') ? _c('el-button', {
    staticClass: "publicity",
    attrs: {
      "plain": true
    },
    on: {
      "click": _vm.togglePublicity
    }
  }, [_c('i', {
    class: ("ppj-icon-" + (_vm.publicity ? 'lock-open-alt' : 'lock')),
    staticStyle: {
      "margin-right": "0.4em"
    }
  }), _vm._v(_vm._s(_vm.publicity ? '公开' : '内部') + "\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.tbcMode) ? _c('el-dropdown', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.readonly),
      expression: "!readonly"
    }],
    staticClass: "move-to",
    attrs: {
      "menu-align": "start"
    },
    on: {
      "command": _vm.moveTo
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v(_vm._s(_vm.$t('actions.project.moveTo'))), _c('i', {
    staticClass: "ppj-icon-down-dir"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "dropdown-wrapper",
    slot: "dropdown"
  }, [_c('div', {
    on: {
      "mouseover": function($event) {
        _vm.hover = true
      },
      "mouseout": function($event) {
        _vm.hover = false
      }
    }
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "all"
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.$t('actions.category.all')))])]), _vm._v(" "), _vm._l((_vm.categories), function(cat, index) {
    return _c('el-dropdown-item', {
      key: cat.id,
      attrs: {
        "command": ("" + (cat.id))
      }
    }, [_c('div', {
      staticClass: "item"
    }, [_vm._v(_vm._s(cat.name))])])
  }), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": "",
      "command": "new"
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('i', {
    staticClass: "ppj-icon-plus"
  }), _vm._v(_vm._s(_vm.$t('actions.category.new')))])])], 2)])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-actions-group"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": _vm.organization && !_vm.tbcMode ? 20 : 24
    }
  }, [_c('p', {
    staticClass: "title",
    class: {
      'tbc': _vm.tbcMode
    }
  }, [_vm._v(_vm._s(_vm.project.name)), _c('span', {
    staticClass: "nickname"
  }, [_vm._v(_vm._s(_vm.project.user.nickname))])])]), _vm._v(" "), (_vm.organization && !_vm.tbcMode) ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "avatar-wrapper"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.project.user.nickname,
      "placement": "left",
      "popper-options": {
        removeOnDestroy: true
      },
      "open-delay": 200
    }
  }, [_c('div', {
    staticClass: "img avatar",
    style: ({
      backgroundImage: 'url(' + _vm.project.user.profile_picture + ')'
    })
  })])], 1)]) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('span', {
    staticClass: "sub-title"
  }, [_c('i', {
    staticClass: "ppj-icon-clock"
  }), _vm._v(_vm._s(_vm.dateReadable(_vm.project.created_at, true)))]), _vm._v(" "), _c('span', {
    staticClass: "sub-title right"
  }, [_c('i', {
    staticClass: "ppj-icon-eye"
  }), _vm._v(_vm._s(_vm.project.pv))])]), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "left"
  }, [(_vm.project.state === 'completed') ? _c('div', {
    staticClass: "btn qrcode",
    on: {
      "mouseover": function($event) {
        _vm.qrcode = true
      },
      "mouseout": function($event) {
        _vm.qrcode = false
      }
    }
  }, [_c('i', {
    staticClass: "ppj-icon-qrcode"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "数据统计",
      "placement": "left",
      "popper-options": {
        removeOnDestroy: true
      }
    }
  }, [_c('div', {
    staticClass: "btn"
  }, [_c('router-link', {
    staticClass: "ppj-icon-chart-bar",
    attrs: {
      "to": ("/projects/" + (_vm.project.id) + "/stats"),
      "tag": "i"
    }
  })], 1)]), _vm._v(" "), _c('el-dropdown', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.readonly),
      expression: "!readonly"
    }],
    staticClass: "btn",
    attrs: {
      "menu-align": "start"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('i', {
    staticClass: "ppj-icon-ellipsis-vert"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "small",
    slot: "dropdown"
  }, [_c('div', {
    on: {
      "mouseover": function($event) {
        _vm.hover = true
      },
      "mouseout": function($event) {
        _vm.hover = false
      }
    }
  }, [_c('el-dropdown-item', [_c('div', {
    staticClass: "item",
    on: {
      "click": _vm.rename
    }
  }, [_c('i', {
    staticClass: "ppj-icon-pencil"
  }), _vm._v(_vm._s(_vm.$t('common.buttons.rename')) + "\n                ")])]), _vm._v(" "), _c('el-dropdown-item', [_c('div', {
    staticClass: "item",
    on: {
      "click": _vm.setThumbnail
    }
  }, [_c('i', {
    staticClass: "ppj-icon-file-image"
  }), _vm._v(_vm._s(_vm.$t('actions.project.alterCover')) + "\n                ")])]), _vm._v(" "), _c('el-dropdown-item', [_c('div', {
    staticClass: "item",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "ppj-icon-trash"
  }), _vm._v(_vm._s(_vm.$t('common.buttons.delete')) + "\n                ")])])], 1)])], 1)], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ppj-icon-eye"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ppj-icon-eye"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ppj-icon-arrows-cw"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5eb9ba96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/list/item/index.vue
// module id = 924
// module chunks = 3